
import { defineComponent } from "vue";
import GameCard from "@/components/GameCard.vue";
import { getGames } from "@/data/games";
import type { Game } from "@/data/games";

export default defineComponent({
  name: "GameSelection",

  components: {
    GameCard,
  },

  computed: {
    games(): Game[] {
      return this.getGames();
    },
  },

  methods: {
    getGames,
    routeTo(game: string) {
      this.$router.push(`/${game}`);
    },
  },
});
